import React from "react";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import {
  buildAttendanceUrl,
  getFilteredAttendanceTotal,
} from "helpers/attendance";
import SidebarItem from "components/SidebarItem";
import { AttendanceItemProps } from "./types";
import { getModelDateFormat } from "components/UneditableMessage";

type StudentAttendanceItemParams = {
  studentItem: string;
  schoolId: string;
};

const StudentAttendanceItem: React.ComponentType<AttendanceItemProps> = ({
  currentStoreData,
  store,
  studentStore,
  thrStore,
  storeToChooseType,
  currentSchoolEnabledStudentAttendance,
  ...extraProps
}) => {
  const params: StudentAttendanceItemParams = useParams();

  // Date from one of the available dates.
  const storeDate: string =
    getModelDateFormat(store) ||
    getModelDateFormat(studentStore) ||
    getModelDateFormat(thrStore) ||
    getModelDateFormat(currentStoreData);

  const selected =
    (currentStoreData &&
      currentStoreData.client_id === studentStore.client_id) ||
    (currentStoreData === undefined &&
      studentStore.client_id === params.studentItem);
  let subTitle: React.ReactElement = (
    <>
      {getFilteredAttendanceTotal({
        attendance: studentStore,
        kinds: ["male"],
      })}{" "}
      <FormattedMessage id="app.boys" defaultMessage="boys" />,{" "}
      {getFilteredAttendanceTotal({
        attendance: studentStore,
        kinds: ["female"],
      })}{" "}
      <FormattedMessage id="app.girls" defaultMessage="girls" />
    </>
  );

  const title = (
    <>
      {getFilteredAttendanceTotal({
        attendance: studentStore,
      })}{" "}
      <FormattedMessage id="app.students" defaultMessage="students" />
    </>
  );

  return (
    <SidebarItem
      {...extraProps}
      store={studentStore}
      selected={selected}
      subTitle={subTitle}
      id={studentStore.client_id}
      key={studentStore.client_id}
      title={title}
      to={buildAttendanceUrl(
        storeDate,
        params.schoolId,
        store?.client_id,
        thrStore?.client_id,
        studentStore?.client_id
      )}
    />
  );
};

export default StudentAttendanceItem;
